<div>
  <div class="boxing" *ngIf="tasks">
    <div class="module" *ngFor="let task of tasks | async">
      <task-card [task]="task"></task-card>
    </div>
  </div>
</div>
